<template>
  <div class="alpha-decay-tunneling-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$U238 → Th234 + α | 赫米特势垒$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Potential Curve (Gamow theory) -->
          <path :d="potentialPath" fill="none" stroke="#888" stroke-width="2" />
          
          <!-- Large Nucleus -->
          <circle cx="100" cy="140" r="30" fill="rgba(255, 71, 87, 0.2)" stroke="#ff4757" />
          
          <!-- Alpha Particle inside -->
          <g :transform="`translate(${alphaX}, ${alphaY})`">
             <circle r="6" fill="#ffa502" stroke="#fff" />
             <text x="-4" y="2" fill="#fff" font-size="6">α</text>
          </g>

          <!-- Warning text -->
          <text x="140" y="60" fill="#ff4757" font-size="8" v-if="alphaX > 130">隧穿发生中...</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ active ? '衰变观测中' : '静态核心' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <el-button type="danger" size="mini" @click="active = true" :disabled="active">开始模拟</el-button>
          <el-button size="mini" @click="reset">重置</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>Alpha 衰变是量子隧穿效应的最佳宏观体现。在核内，Alpha 粒子被极强的**核力**束缚在一个势阱中，外部则是强大的库仑斥力形成的势垒。经典物理认为能量不足的 Alpha 粒子永无出头之日，但量子力学允许它以极小的概率穿越势垒。这种概率极其敏感地取决于势垒的宽度，这完美解释了为什么不同元素的半衰期可以从纳秒到数十亿年不等。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlphaDecayTunnelingViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      active: false,
      alphaX: 100,
      alphaY: 140,
      t: 0,
      timer: null
    }
  },
  computed: {
    potentialPath() {
       const pts = [];
       for (let x = 70; x <= 400; x += 5) {
          let y;
          if (x < 130) {
             y = 140 + Math.pow(x - 100, 2) * 0.1 - 40; // The Well
          } else {
             y = 140 - 1000 / (x - 110); // The Coulomb Barrier
          }
          if (y < 40) y = 40;
          if (!isNaN(y)) pts.push(`${x},${y.toFixed(1)}`);
       }
       return pts.length > 0 ? "M " + pts.join(" L ") : "";
    }
  },
  methods: {
    animate() {
       this.t++;
       if (!this.active) {
          // Vibrating inside
          this.alphaX = 100 + Math.sin(this.t * 0.5) * 15;
          this.alphaY = 140 + Math.cos(this.t * 0.5) * 5;
       } else {
          // Escaping (tunneling jump)
          if (this.alphaX < 130) {
             this.alphaX = 135; // The "Jump"
          } else {
             this.alphaX += 5; // Flying away
             this.alphaY -= 1;
          }
       }
       this.timer = requestAnimationFrame(this.animate);
    },
    reset() {
       this.active = false;
       this.alphaX = 100;
       this.alphaY = 140;
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.alpha-decay-tunneling-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .brief { font-size: 13.5px; color: #1e293b; font-weight: 500; } .formula-chip { color: #ff4757; background: rgba(255, 71, 87, 0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
